module.exports = __webpack_public_path__ + "static/img/image378-2.8d42bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/image378-2.png
// module id = UG1D
// module chunks = 134